import { render, staticRenderFns } from "./selectOrderWay.vue?vue&type=template&id=a237b874&scoped=true&"
import script from "./selectOrderWay.vue?vue&type=script&lang=js&"
export * from "./selectOrderWay.vue?vue&type=script&lang=js&"
import style0 from "./selectOrderWay.vue?vue&type=style&index=0&id=a237b874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a237b874",
  null
  
)

export default component.exports